// this is an autogenerated file from App/Account/Content/Settings/Content/Leads/Content/Content/Settings/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_Leads_Content_Content_Settings(
  $inserts: [leads_settings_insert_input!]!
  $updates: [leads_settings_updates!]!
  $insert_settings: Boolean!
  $update_settings: Boolean!
) {
  insert_leads_settings(objects: $inserts) @include(if: $insert_settings) {
    affected_rows
    returning {
      id
    }
  }
  update_leads_settings_many(updates: $updates) @include(if: $update_settings) {
    affected_rows
    returning {
      id
    }
  }
}

`